var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"caddress acenter",class:{ 'caddress--no-link': _vm.disableMapLink },on:{"click":_vm.handleClick}},[_c('div',[_c('img',{staticClass:"caddress__image",attrs:{"src":require('base/navigation.svg')}})]),_vm._v(" "),_c('div',[_vm._v(_vm._s(this.format))])])
}
var staticRenderFns = []

export { render, staticRenderFns }